import { getLink } from "../../../utils/utils";

import author from "./author";

const content = {
	esp: (
		`
		<p>
			A.P. Ĉeĥov, ŝajne, estas la plej konata eksterlande rusa literaturisto. 
			Mi temas ne pri la nomo, sed pri la verkoj. 
			Klare, ke la nomoj de L. Tolstoj kaj F. Dostojevskij estas pli ofte uzataj kaj rememorataj, kiam temas pri rusa literaturo; sed, sincere dirate, ĉu multaj legis ilin? 
			Ja longaj verkoj… en nia dinamika tempo… 
			Sed Ĉeĥov, kiu verkis nur kurtajn rakontojn, estas pli komprenebla kaj pli proksima al eŭropa, ĉina, japana animo. 
			Oni ofte tradukas lin al diversaj lingvoj… kaj foje eĉ legas!
		</p>
		
		<p class="mb-3">
			Ricevis li sian merititan agnoskon ankaŭ en Esperantujo. 
			En 2004 estis tradukita lia teatraĵo «Ĉeriza ĝardeno», kaj en 2005 aperis traduko de dua el kvar liaj famaj teatraĵoj, la «Onklo Vanja». 
			Plenumis ĝin fama poeto kaj bardo M. Povorin. 
			Kaj bone plenumis.
		</p>
		
		<p class="mb-3">
			La subnomo de la verko estas: «Scenoj el vilaĝa vivo en kvar aktoj». 
			La teatraĵoj de Ĉeĥov tute ne konformas al kutima, tradicia formo de teatraĵo, kiun nu vidas en verkoj de Shakespeare, Schiller, Molliere, G. B. Shaw aŭ iu ajn el klasikuloj. 
			La ĉefa postulo al klasika dramo – vigla kaj streĉa intrigo kiel spino de la tuta verko, la ago kiel risorto, kiu forte frapas ĉe l’ finalo. 
			Nenion tian oni trovas en dramoj de Ĉeĥov. 
			Nek akra intrigo, nek pasioj… 
			Fakte, pasioj bolas – sed nur interne. 
			Oni ne povas ĝuste indiki la ĝenron de liaj teatraĵoj; verŝajne, ili estas tragedioj de la plej ordinaraj homoj: tiaj ĉiutagaj tragedioj, kiujn neniu rimarkas: nemajestaj, nelaŭtaj, nebrilaj. 
			La tragismo de ĉiutageco korodas la vivojn; kaj samtempe la flamo de talento, de alta alvokiĝo lumigas la vivojn kaj animojn de tiuj plej ordinaraj homoj.
		</p>
		
		<p class="mb-4">
			Ĉeĥov estas unu el fondintoj de nova literaturo, almenaŭ en sfero de teatraj verkoj. 
			En liaj teatraĵoj gravas paŭzoj: ili kvazaŭ donas la duan dimension al simplaj frazoj, kondukante nin de ŝajne trivialaj eldiroj al ilia profunda signifo, montranta la internan vivon, la verajn sentojn de protagonistoj.
		</p>
		
		<div class="mb-4">
			<p>
				«Jes, delonge oni ne kiuris ĉe ni nudelojn». Paŭzo. Sed iel videblas, ke la tuta vivoordo estas rompita. Aŭ:
			</p>
			<div style="width:540px">
				<p>Vojnickij: Mi silentas. Silentas kaj pardonpetas.</p>
				<p class="text-center">Paŭzo.</p>
				<p>Jelena Andrejevna: Bona vetero estas hodiaŭ… Ne varmegas…</p>
				<p class="text-center">Paŭzo.</p>
				<p>Vojnickij: En tia vetero estas bone pendumi sin…</p>
			</div>
		</div>
		
		<p class="mb-3">
			Vera intrigo de verkoj de Ĉeĥov okazas en la mensoj, en interna vivo. 
			Li mem diris, ke li volas ne verki «bonan dramon», sed demonstri en la sceneja formo la vivon, kie: «homoj tagmanĝas, nur tagmanĝas, sed en tiu tempo kreiĝas ilia feliĉo aŭ frakasiĝas iliaj vivoj». 
			Post Ĉeĥov’aj verkoj oni nomas tiun novan formon de drama strukturo «interna intrigo»: 
			Ĉiu protagonisto estas enmergita en sian propran mondon, propran mensocirklon, ĉiu elradias sian specifan ondolongon, kaj ĉio kune faras strangan simfonion. 
			Apartaj sonoj interplektiĝas aĵure, jen kunproksimiĝas en akordo, jen disiĝas… sed ĉiu estas sola kaj soleca. 
			En dramoj de Ĉeĥov forestas feliĉa amo: tiu, kiu amas, estas malfeliĉa, kaj feliĉas nur senanimaj egoistoj, tute ne kapablaj ami. 
			Eble, ankaŭ pro tio dramoj de Ĉeĥov estas komprenataj de nuntempa publiko; li vere estas unu el fondintoj de nuntempa literaturo.
		</p>
		
		<p>
			La paroloj estas strangaj sed neniam hazardaj. 
			Ĉiu plej triviala rimarko karakterizas la animstaton de l’ persono. 
			Ekzemple, en genia finalo de «Onklo Vanja», post pafoj, provo de suicido, ardaj dialogoj, - evidentiĝas, ke la viva katastrofo de la onkolo Vanja esprimiĝas ne en tiuj efektaj scenejaj agoj, sed en ŝajne preteraj vortoj de Astrov: 
			«He, verŝajne en tiu Afriko nun estas varmego – terura afero!»
		</p>
		
		<p>
			Ĝenerale, la teatraĵo plenas de «flugilhavaj esprimoj», kiuj nun iĝis konataj al ĉiu klera rusa homo. 
			«Ni vidos la ĉielon plenan de diamantoj» – oni diras pri plenumo de plej altaj aspiroj. 
			«En la homo ĉio devas esti belega: kaj la vizaĝo, kaj la vesto, kaj la animo, kaj la pensoj» – la citaĵo eĉ trivita en sovetia tempo.
		</p>
		
		<p class="mb-3">
			Frapmirigas ankoraŭ unu trajto de tiu ĉi verko de Ĉeĥov. 
			Ĉirkaŭ 30 jarojn antaŭ la apero de la vorto mem «ekologio», des pli de la nocio mem, Ĉeĥov per la buŝo de doktoro Astrov, fakte sia «alter ego», proklamis neceson de amo al naturo, zorgo kaj estimo al ĝi.
		</p>
		
		<p class="mb-3">
			Astrov: La rusaj arbaroj krakas sub toporoj, pereas miliardoj da arboj, malpleniĝas la loĝlokoj de bestoj kaj birdoj, malprofundiĝas kaj sekiĝas riveroj, malaperas senrevene mirindaj pejzaĝoj… 
			Nur malprudenta barbaro povas bruligi … tiun belon, detrui tion, kion ni ne povas krei. 
			La homo estas dotita per racio kaj krea forto por multigi tion, kion oni donis al li. 
			Tamen ĝis nun li ne kreadis, sed detruadis. 
			Arbaroj pli kaj pli malmultas, riveroj sekiĝas, sovaĝaj bestoj formortis, la klimato estas difektita, kaj ĉiutage la tero iĝas pli kaj pli malriĉa kaj hida.
		</p>
		
		<p>
			Siatempe la publiko ne komprenis tiujn vortojn, eĉ primokis ilin - tiel malkutimaj kaj strangaj ili ŝajnis. 
			Sed kiel aktualaj ili ŝajnas nun! Vere, Ĉeĥov antaŭvidis ne nur novan literaturon, sed ankaŭ novan vivon, - kaj tial liaj komedioj estas tiel tristaj…
		</p>

		<p>
			Li mortis antaŭ 115 jaroj (en 1904); sed liaj verkoj temas ankaŭ pri ni. 
			Ili ne restis limigitaj en sia epoko, ili bezonatas al ni kaj estos bezonataj al estontaj generacioj. 
			Tradukitaj al Esperanto, ili ankoraŭ alproksimiĝis al tutmonda legantaro.
		</p>

		<p class="mb-3">
			Interalie, interesa paralelo okazas inter Ĉeĥov kaj Zamenhof. 
			Ambaŭ estas kuracistoj, kaj ambaŭ ĝis la morto daŭrigis sian kuracistan praktikon, kaj kuracis plejofte senpage malriĉulojn. 
			Ambaŭ donis precipan atenton al homaj suferoj, doloroj, internekompreniĝo, kaj strebis reale helpi, kaj kiel doktoroj, kaj en sia krea agado.
		</p>
		
		<p>
			Oni devas diri pri la lingvaĵo de la traduko. 
			La lingvaĵo de Ĉeĥov ĉiam estas tre simpla, parolflua kaj absolute trafa. 
			Mi povas same diri pri la traduko: simpla, sed riĉa vortelekto, nenie pretendemaj stilumaĵoj, kiujn tiel ne ŝatis Ĉeĥov. 
			La alta kulturo de vorto. 
			Eble, alilingvanoj trovos rusismojn – sed mi, estante ruslingva, ne povas ilin rimarki.
		</p>

		<p>
			Kaj ankoraŭ unu trajto, unike miriga por Esperantaj eldonaĵoj: en la libro tute forestas preseraroj! 
			Verŝajne, ni devas danki pro tio redaktoron kaj provlegiston – sed, bedaŭrinde, nek tiu, nek aliu estas nomitaj. 
			En la libro mankas ajnaj eldondatenoj, krom la jaro kaj la loko. 
			Laŭ mi, tio estas sola ĝia manko.
		</p>
		`
	)
}

const itemName = {
	esp: 'Pri doktoroj kaj homoj malsanaj (pri «Onklo Vanja» de A. P. Ĉeĥov)'
}

const itemBookInfo = {
	esp: {
		bookName: 'Onklo Vanja',
		content: `
			<p>
				Aŭtoro: Anton Pavloviĉ Ĉeĥov
			</p>
		`
	}
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemAuthor: author.esp,
		itemBookInfo: itemBookInfo.esp,
		itemTranslator: `
			El la rusa tradukis Mikaelo Povorin. <br/>
			Literatura suplemento al la gazeto REGO, Moskvo, 2005. 44 p.
		`
	}
}

export default item;

